import { Injectable, EventEmitter } from '@angular/core';
import { Subject, BehaviorSubject, Observable } from 'rxjs';
import { Horse_show } from '../models/horse_show';
import { Horse_show_entry } from '../models/horse_show_entry';
import { Entry_type } from '../models/entry_type';
import { Entry_builder } from '../models/entry_builder';

@Injectable()
export class EntryBuilderService {
  
  private _horse_show:Subject<Horse_show> = new BehaviorSubject<Horse_show>(new Horse_show({}));
  private _horse_show_entry:Subject<Horse_show_entry> = new BehaviorSubject<Horse_show_entry>(new Horse_show_entry({}));
  private _entry_type: Subject<Entry_type> = new BehaviorSubject<Entry_type>(new Entry_type({}));
  private _billing_handled: Subject<boolean> = new BehaviorSubject<boolean>(false);
  private _competitions_entered: Subject<boolean> = new BehaviorSubject<boolean>(false);
  private _payee_completed: Subject<boolean> = new BehaviorSubject<boolean>(false);
  private _entry_finalized: Subject<boolean> = new BehaviorSubject<boolean>(false);

  private entry_builder: Entry_builder;

  public horse_show$: Observable<Horse_show> = this._horse_show.asObservable();
  public horse_show_entry$: Observable<Horse_show_entry> = this._horse_show_entry.asObservable();
  public entry_type$: Observable<Entry_type> = this._entry_type.asObservable();
  public billing_handled$: Observable<boolean> = this._billing_handled.asObservable();
  public competitions_entered$: Observable<boolean> = this._competitions_entered.asObservable();
  public payee_completed$: Observable<boolean> = this._payee_completed.asObservable();
  public entry_finalized$: Observable<boolean> = this._entry_finalized.asObservable();

  constructor(){
    let str_entry_builder = localStorage.getItem("ENTRY_BUILDER");
    if(str_entry_builder != null){
      const parsed = JSON.parse(str_entry_builder);

      if(parsed.schema_version !== Entry_builder.CURRENT_SCHEMA_VERSION){
        // Stored entry is from a different schema — discard it so stale
        // data structures don't crash the app after a deployment.
        localStorage.removeItem("ENTRY_BUILDER");
        this.entry_builder = new Entry_builder();
        return;
      }

      this.entry_builder = parsed;

      if(this.entry_builder.horse_show.hasOwnProperty("id")){
        this._horse_show.next(this.entry_builder.horse_show);
      }

      //Pending entry won't have an ID yet but it will have a trainer
      if(this.entry_builder.horse_show_entry.hasOwnProperty("trainer")){
        this._horse_show_entry.next(this.entry_builder.horse_show_entry);
      }

      if(this.entry_builder.entry_type.hasOwnProperty("number")){
        this._entry_type.next(this.entry_builder.entry_type);
      }

      if(this.entry_builder.billing_handled){
        this._billing_handled.next(true);
      }

      if(this.entry_builder.competitions_entered){
        this._competitions_entered.next(true);
      }

      if(this.entry_builder.payee_completed){
        this._payee_completed.next(true);
      }

      if(this.entry_builder.entry_finalized){
        this._entry_finalized.next(true);
      }

    } else {
      this.entry_builder = new Entry_builder();
    }
  }
  
    public setHorse_show(horse_show: Horse_show){
      this.entry_builder.horse_show = horse_show;
      localStorage.setItem("ENTRY_BUILDER", JSON.stringify(this.entry_builder));
      this._horse_show.next(horse_show);
    }
   
    public setHorse_show_entry(horse_show_entry: Horse_show_entry){
      this.entry_builder.horse_show_entry = horse_show_entry;
      localStorage.setItem("ENTRY_BUILDER", JSON.stringify(this.entry_builder));
      this._horse_show_entry.next(horse_show_entry);
    }
    
    public setEntry_type(entry_type: Entry_type){
      //console.log(entry_type);
      this.entry_builder.entry_type = entry_type;
      localStorage.setItem("ENTRY_BUILDER", JSON.stringify(this.entry_builder));
      this._entry_type.next(entry_type);
    }

    public setBilling_handled(is_handled:boolean){
      this.entry_builder.billing_handled = is_handled;
      localStorage.setItem("ENTRY_BUILDER", JSON.stringify(this.entry_builder));
      this._billing_handled.next(is_handled);
    }

    public setCompetitions_entered(entered: boolean){
      this.entry_builder.competitions_entered = entered;
      localStorage.setItem("ENTRY_BUILDER", JSON.stringify(this.entry_builder));
      this._competitions_entered.next(entered);
    }

    public setPayee_completed(completed: boolean){
      this.entry_builder.payee_completed = completed;
      localStorage.setItem("ENTRY_BUILDER", JSON.stringify(this.entry_builder));
      this._payee_completed.next(completed);
    }

    public setEntry_finalized(finalized: boolean){
      this.entry_builder.entry_finalized = finalized;
      localStorage.setItem("ENTRY_BUILDER", JSON.stringify(this.entry_builder));
      this._entry_finalized.next(finalized);
    }

  public reset(){

    localStorage.removeItem("ENTRY_BUILDER");
    this.setHorse_show(new Horse_show({}));
    this.setEntry_type(new Entry_type({}));
    this.setHorse_show_entry(new Horse_show_entry({}));
    this.setBilling_handled(false);
    this.setCompetitions_entered(false);
    this.setPayee_completed(false);
    this.setEntry_finalized(false);
    this.entry_builder = new Entry_builder();

  }

  private entered_show_ids = new Set<string>();

  public markShowEntered(horse_show_id: string): void {
    if (horse_show_id) this.entered_show_ids.add(horse_show_id);
  }

  public hasEnteredShow(horse_show_id: string): boolean {
    return !!horse_show_id && this.entered_show_ids.has(horse_show_id);
  }

}
